export default {
  ACTIVE: "0",
  SUPPRESS_PROLONGATION: "1",
  BEING_EDITED: "2",
  SUSPENDED: "3",
  REQUESTED: "6",
  PREMIUM_FREE: "7",
  QUOTATION: "8",
  ACTIVE_ELSEWHERE: "9",
  SINGLE_PREMIUM_POLICY: "10",
  REDEMPTION: "11",
  NO_INSURRANCE: "12",
  VALUE_TRANSFERRED: "13",
  EXHALED: "14",
  SHORTERM_INSURANCE: "15",
  PREMIUM_VACANCY: "16",
  TAKING_INVENTORY: "30",
  IN_PROLONGATION: "99",
  REJECTED: "996",
  ENDING: "997",
  EXPIRING: "998",
  EXPIRED: "999",
};
